import { Component, Inject, ViewChild, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { ApiService } from '@angular/synthrone-design/services';
import { APP_CONFIG } from '@synthroneApp/app.config';

import { MatDialog } from '@angular/material';
import { AlertComponent } from '@angular/synthrone-design/components';
import { ClientServiceSDK, AccountClientServiceSDK } from 'ms-client-angular-sdk';

@Component({
  selector: 'app-organizations-view',
  templateUrl: './organizations-view.component.html',
  styleUrls: ['./organizations-view.component.scss']
})

export class OrganizationsViewComponent  {

  @ViewChild('organizationsTable') organizationsTable;

  configColumns = {
    name: {
      label: 'Name',
      sortable: false,
      truncate: true
    },
    planet: {
      label: 'Planet',
      sortable: false,
      truncate: true
    }
  };

  queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
  timeout = null;
  clients: any[] = [];

  constructor(private _router: Router,
              private route: ActivatedRoute,
              protected api: ApiService,
              @Inject(APP_CONFIG) private config,
              protected dialog: MatDialog,
              private clientService: ClientServiceSDK,
              private accountClient: AccountClientServiceSDK) { }


  ngOnInit() {
    this.getClients().then(() => {
      this.route.queryParams.subscribe(() => { this.refreshTable() });
    })
  }

  refreshTable = () => {
      this.organizationsTable.getData()
  };

  editRow = (key) => {
      this._router.navigate(['/organizations/edit', key]);
  }

  editOrganizationComponents = (planet) => {
      this._router.navigate(['/organizations/components/', planet]);
  }

  editOrganizationFeatures = (planet) => {
    this._router.navigate(['/organizations/features/', planet]);
  }

  editOrganizationFonts = (planet) => {
      this._router.navigate(['/organizations/fonts/', planet]);
  }

  editParametersRow = (key) => {
      this._router.navigate(['/organizations/parameters', key]);
  }

  sdClient = (limit: any, offset: any): Observable<any> => {
    return Observable.of(this.clients);
  }

  getClients(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.api.makeSDKRequest(this.clientService, 'clientsGet', false)
        .subscribe((results: any[]) => {
          this.clients = results;
          resolve();
        })
    })

  }

  addClient = () => {
      this._router.navigate(['/organizations/add']);
  }

  searchProductFN = () => {

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this._router.navigate(['/organizations/1/10/'], { relativeTo: this.route, queryParams: this.queryParams });
        this.refreshTable();
      }, 2000);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/views/organizations-view/organizations-view.component.ts